import {Auth0Client} from '@auth0/auth0-spa-js';

export interface EnhancedAuth0Client extends Auth0Client {
  getTokenSilentlyWithFallback: () => Promise<string>;
}

let auth0Instance: EnhancedAuth0Client;

if (process.env.NODE_ENV !== 'test') {
  const baseClient = new Auth0Client({
    domain: process.env.REACT_APP_AUTH0_DOMAIN as string,
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID as string,
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
    authorizationParams: {
      redirect_uri: `${window.location.origin}/callback`
    },
    useRefreshTokensFallback: false
  });

  auth0Instance = Object.assign(baseClient, {
    getTokenSilentlyWithFallback: async (): Promise<string> => {
      try {
        return await baseClient.getTokenSilently({
          timeoutInSeconds: 60
        });
      } catch (error) {
        console.error('Token refresh failed:', error);

        if (error.error === 'login_required' || error.error === 'consent_required') {
          throw new Error('Authentication required - please log in again');
        }

        if (error.error === 'network_error') {
          throw new Error('Network error - please check your connection and try again');
        }

        try {
          const token = await baseClient.getTokenWithPopup();

          if (!token) {
            throw new Error('Token is undefined - please log in again');
          }

          return token;
        } catch (popupError) {
          console.error('Popup token refresh failed:', popupError);
          throw new Error('Token refresh failed - please log in again');
        }
      }
    }
  }) as EnhancedAuth0Client;
} else {
  auth0Instance = {
    getUser: jest.fn(),
    getIdTokenClaims: jest.fn(),
    loginWithRedirect: jest.fn(),
    handleRedirectCallback: jest.fn(),
    checkSession: jest.fn(),
    getTokenSilently: ()=>Promise.resolve('token'),
    getTokenSilentlyWithFallback: ()=>Promise.resolve('token'),
    getTokenWithPopup: jest.fn(),
    isAuthenticated: ()=>Promise.resolve(true),
    logout: jest.fn()
  } as unknown as EnhancedAuth0Client;
}
export default auth0Instance;
